export const OPTION_PREFIX = "option-";
export var CustomizeModalText;
(function (CustomizeModalText) {
    CustomizeModalText["CONFIRM"] = "Confirm";
    CustomizeModalText["TOTAL"] = "Total:";
    CustomizeModalText["CUSTOMIZE_MEAL"] = "Customize Meal";
    CustomizeModalText["REMOVE_MEAL"] = "Remove Meal";
    CustomizeModalText["BACK_BUTTON"] = "Back";
})(CustomizeModalText || (CustomizeModalText = {}));
export var InputHelperText;
(function (InputHelperText) {
    InputHelperText["DEFAULT"] = "Select between {min} and {max} {ingredients}.";
    InputHelperText["UP_TO_MAX"] = "Select up to {max} {ingredients}.";
    InputHelperText["MUST_SELECT"] = "At least {min} {ingredients} must be selected.";
    InputHelperText["EXCEEDED_MAX"] = "You have exceeded the maximum limit of {max} {ingredients}.";
})(InputHelperText || (InputHelperText = {}));
export var InputTypes;
(function (InputTypes) {
    InputTypes["CHECKBOX"] = "checkbox";
    InputTypes["DROPDOWN"] = "dropdown";
    InputTypes["RADIOBUTTON"] = "radiobutton";
})(InputTypes || (InputTypes = {}));
